import { CapacityTypeBase } from './base/capacity-type-base';

export class CapacityType extends CapacityTypeBase { }